import { api1 } from "../utils/axiosInstance";

export const getBankDetails = async (userId) => {
  try {
    const response = await api1.get(`/api/stripe/account-status/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    return null;
  }
};
